<template>
  <div>
    <div class="d-flex flex-column" dir="rtl" v-if="content?.form?.iframe_url">
      <div class="d-flex flex-row">
        <button type="button" class="f20-l30-b pointer popup-close-btn" @click="$emit('close')" aria-label="סגור">X</button>
        <h2 :id="popupTitleId" class="f20-l30-b flex-grow-1 text-center heading-reset" v-html="content.title"></h2>
      </div>
      <div class="f14-l17 flex-grow-1" v-html="content.subtitle"></div>
      <div class="f14-l17 red" id="popup-error-message" role="alert" aria-live="polite"></div>
      <div class="f14-l17 red" id="popup-error-message-description"></div>
      <LoadingIndicator dir="ltr" v-if="popupLoadingIndicator" />
      <iframe :src="content?.form?.iframe_url" :title="iframeTitle" :class="classSelector()" :allow="this.$isGOOGLE() ? 'payment' : null"></iframe>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.form?.auth_code">
      <div class="d-flex flex-row">
        <button type="button" class="f20-l30-b pointer popup-close-btn" @click="$emit('close')" aria-label="סגור">X</button>
        <h2 :id="popupTitleId" class="f20-l30-b flex-grow-1 text-center heading-reset" v-html="content.title"></h2>
      </div>
      <div class="f14-l17 flex-grow-1" v-html="content.subtitle"></div>
      <div class="f14-l17 red" id="popup-error-message" role="alert" aria-live="polite"></div>
      <div class="f14-l17 red" id="popup-error-message-description"></div>
      <LoadingIndicator dir="ltr" v-if="popupLoadingIndicator" />
      <div id="grow-wallet-container" class="grow_wallet_container" role="region" :aria-label="iframeTitle"></div>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.form?.hosted_fields">
      <TranzilaHostedFieldsForm :content="content" :popupTitleId="popupTitleId" @close="$emit('close')" />
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.form">
      <div class="d-flex flex-row">
        <button type="button" class="f20-l30-b pointer popup-close-btn" @click="$emit('close')" aria-label="סגור">X</button>
        <h2 :id="popupTitleId" class="f20-l30-b text-center flex-grow-1 heading-reset" v-html="content.title"></h2>
      </div>
      <div v-if="content.description" class="f14-l17 margin-tb-20 text-center" v-html="content.description"></div>
      <form class="formfield-round-border formfield-16" dir="rtl" :action="content.form?.submit?.url || content.form?.submit?.href || content.form.button.href" ref="form" :method="content.form?.submit?.method || `POST`" @submit.prevent="false" @keyup.enter="onSubmit">
        <FormFieldComponent :field="customizeField(field)" v-for="(field,idx) in content.form.fields" :key="field.data_name || 'field_' + idx" />
        <button
          v-if="content.form.new_address?.popup?.form"
          type="button"
          class="red f14-l17 formfield-margin-wrapper padding-tb-10 pointer new-address-btn"
          @click="openpopup(content.form.new_address.popup.form)"
        >{{content.form.new_address.popup.form.title}}</button>
        <div class="f14-l17 red text-center" v-if="errorMessage" v-html="errorMessage" role="alert" aria-live="polite"></div>
        <div class="f14-l17 text-center" v-if="responseMessage" v-html="responseMessage"></div>
        <div v-if="isSubmitting" class="loader-container">
          <LoadingIndicator dir="ltr" />
        </div>
        <div v-else-if="responseButtons.length === 0" >
          <div v-if="content.form.buttons">
            <div class="d-flex flex-row">
              <ButtonComponent  class="flex-grow-1 margin-lr-5" v-for="btn in content.form.buttons" :key="btn.label" :caption="btn.label" @click="btnAction(btn)" @keyup.enter="btnAction(btn)" :variant="btn?.variant || 'red'" />
            </div>
          </div>
          <ButtonComponent v-else-if="content.form?.submit || content.form?.button" :caption="content.form?.submit?.label || content.form.button.label" @click="onSubmit" @keyup.enter="onSubmit" class="margin-top-20" :variant="content.form?.submit?.variant || content.form?.button?.variant || 'red'" />
        </div>
        <div v-else class="button-group">
          <ButtonComponent v-for="(btn, index) in responseButtons" :key="index" :caption="btn.label" @click="btnAction(btn)" @keyup.enter="btnAction(btn)" class="margin-top-20"  :variant="btn?.variant || 'red'" />
        </div>
      </form>

    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="campaignOffer">
      <div class="d-flex flex-row">
        <button type="button" class="f20-l30-b pointer popup-close-btn" @click="$emit('close')" aria-label="סגור">X</button>
        <h2
          v-if="content?.header?.title_html"
          :id="popupTitleId"
          class="text-center f20-l20-b df30-l30-b flex-grow-1 margin-top-10 heading-reset"
          v-html="content.header.title_html"
        ></h2>
      </div>
      <div
        v-if="content?.body?.text_html"
        :id="popupAlertBodyId"
        class="text-center f14-l17 margin-top-10"
        v-html="content.body.text_html"
      ></div>
      <div
        v-for="(btn, idx) in (content?.buttons || [])"
        :key="'campaign-btn-' + idx + '-' + (btn.label || '')"
        class="campaign-offer-btn-wrap margin-top-20"
      >
        <ButtonComponent
          :caption="btn.label"
          :variant="btn?.variant || 'red'"
          :disabled="posting"
          @click="campaignBtnAction(btn)"
          @keyup.enter="campaignBtnAction(btn)"
        />
        <div v-if="btn.disclaimer" class="campaign-offer-disclaimer">{{ btn.disclaimer }}</div>
      </div>
      <div
        v-for="(link, idx) in (content?.links || [])"
        :key="'campaign-link-' + idx + '-' + (link.label || '')"
        class="campaign-offer-btn-wrap margin-top-10"
      >
        <ButtonComponent
          :caption="link.label"
          :variant="link?.variant || 'link'"
          :disabled="posting"
          @click="campaignBtnAction(link)"
          @keyup.enter="campaignBtnAction(link)"
        />
      </div>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.body">
      <div class="d-flex flex-row">
        <button type="button" class="f20-l30-b pointer popup-close-btn" @click="$emit('close')" aria-label="סגור">X</button>
        <h2 :id="popupTitleId" class="f20-l30-b flex-grow-1 text-center heading-reset" v-html="content.header.title_html"></h2>
      </div>
      <HorizontalSplitter class="margin-tb-20" />
      <div :id="popupAlertBodyId" class="f14-l17 red-link" role="alert" v-html="content.body.text_html"></div>
      <HorizontalSplitter class="margin-tb-20" />
      <div class="d-flex flex-row">
        <ButtonComponent class="flex-grow-1 margin-lr-5" v-for="btn in content.buttons" :key="btn.label" :caption="btn.label" @click="btnAction(btn)" @keyup.enter="btnAction(btn)"  :variant="btn?.variant || 'red'" />
        <!-- <ButtonComponent :caption="btn.label" v-if="!btn.cancel"  /> -->
      </div>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.popup_content">
      <div class="d-flex flex-column">
        <div  class="d-flex flex-row">
          <button type="button" class="f20-l30-b pointer popup-close-btn" @click="$emit('close')" aria-label="סגור">X</button>
          <SvgImage v-if="content.popup_content.header.image" :src="content.popup_content.header.image.src" style="height: 130px;" class="margin-top-5 mx-auto align-self-center popup-header-image" />
          </div>
        <div class="d-flex flex-row">
          <h2 v-if="content.popup_content.header.title_html" :id="popupTitleId" class="text-center f20-l20-b df30-l30-b flex-grow-1 margin-top-10 heading-reset" v-html="content.popup_content.header.title_html"></h2>
          </div>
      </div>
      <!-- <ImgImage v-if="content.popup_content.header.image" :img="$responsive(content.popup_content.header.image)" class="margin-top-5 mx-auto align-self-center" /> -->
      <div class="text-center f14-l17 margin-top-10" v-html="content.popup_content.body.description"></div>
      <div class="d-flex flex-row">
        <ButtonComponent class="flex-grow-1 margin-lr-5 margin-top-20" v-for="btn in content.popup_content.buttons" :key="btn.label" :caption="btn.label" @click="btnAction(btn)" @keyup.enter="btnAction(btn)"  :variant="btn?.variant || 'red'" />
        <!-- <ButtonComponent :caption="btn.label" v-if="!btn.cancel"  /> -->
      </div>


    </div>


    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.dish">
      <div class="d-flex flex-row">
        <button type="button" class="f20-l30-b pointer popup-close-btn" @click="$emit('close')" aria-label="סגור">X</button>
        <h2 :id="popupTitleId" class="f20-l30-b flex-grow-1 text-center heading-reset" v-html="content.title"></h2>
      </div>
      <HorizontalSplitter class="margin-tb-20" />

      <div class="d-flex flex-row">
        <ImgImage :img="$responsive(content.dish.image)" />
        <div class="d-flex flex-column padding-10 w-100">
          <div class="d-flex flex-row w-100">
            <div class="f15-l18-m flex-grow-1 ">{{content.dish.title}}</div>
            <div class="f15-l18-m text-nowrap">
              <PriceComponent :value="content.dish.price" />
            </div>
          </div>
          <div class="f14-l19 margin-top-5 c58">{{content.dish.description}}</div>
          <div class="f14-l19 c58" v-for="(option,idx) in content.dish.deal_options" :key="idx">{{option.text}}</div>
          <div class="f14-l19 bold">{{content.dish.amount.text}}</div>
          <div class="f14-l19 red">{{content.dish.cook.text}}</div>
        </div>

      </div>
      <form class="formfield-round-border formfield-16" :action="content.dish.dish_comment.field.update_url" ref="form" method="POST">
        <FormFieldComponent :field="content.dish.dish_comment.field" />
      </form>
      <HorizontalSplitter class="margin-tb-20" />
      <div class="d-flex flex-row">
        <ButtonComponent class="flex-grow-1 margin-lr-5" v-for="btn in content.buttons" :key="btn.text" :caption="btn.text" @click="btnAction(btn)" @keyup.enter="btnAction(btn)" :variant="btn?.variant || 'red'" />
      </div>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="content?.str">
      <div :id="popupAlertBodyId" class="d-flex flex-row" role="alert" v-html="content.str">
      </div>
    </div>

    <div class="d-flex flex-column" dir="rtl" v-else-if="contentIsString()">
      <div :id="popupAlertBodyId" class="d-flex flex-row" role="alert" v-html="content">
      </div>
    </div>

    <WizardPopupComponent v-if="wizard" :wizard="wizard" @close="$emit('close')" />
  </div>
</template>
<script>
import {formSubmit, fetch2, baseUrl} from '@/modules/configuration.js';
import {
  AUTH_CODE_RETRY_HE,
  canOpenGrowWallet,
  invalidateGrowWalletAttempt,
  makeSdkHandlers,
  normalizeAuthCode,
  renderGrowWallet,
  setGrowWalletSession,
} from '@/modules/growSdk.js';
import {
  SESSION_EXPIRED_HE,
  remainingHandshakeMs,
  teardownTranzilaSession,
} from '@/modules/tranzilaHostedFields.js';
import TranzilaHostedFieldsForm from "@/components/popup/TranzilaHostedFieldsForm.vue";
import {openCart} from '@/modules/utils.js';
import ButtonComponent from "@/components/form/ButtonComponent"
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue"
import ImgImage from "@/components/generic/ImgImage.vue"
import FormFieldComponent from "@/components/form/FormFieldComponent"
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import PriceComponent from "@/components/generic/PriceComponent.vue";
import WizardPopupComponent from "@/components/search/WizardPopupComponent";
import SvgImage from "@/components/generic/SvgImage.vue";
import popupA11yChildMixin from '@/mixins/popupA11yChildMixin.js';

export default {
  mixins: [popupA11yChildMixin],
  components: {
    ButtonComponent,
    HorizontalSplitter,
    ImgImage,
    FormFieldComponent,
    LoadingIndicator,
    PriceComponent,
    WizardPopupComponent,
    SvgImage,
    TranzilaHostedFieldsForm,
  },
  props: {
    content: Object,
    url: Object,
    campaignOffer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popupLoadingIndicator: false,
      growSafetyTimer: null,
      tranzilaSafetyTimer: null,
      growMountToken: 0,
      growLastMountedAuthCode: null,
      loading: false,
      wizard: null,
      errorMessage: null,
      isSubmitting: false,
      responseMessage: null,
      responseButtons: [], // Changed to an array
      posting: false,
      popupTitleId: `popup-title-${this._.uid}`,
      popupAlertBodyId: `popup-alert-body-${this._.uid}`,
    }
  },
  mounted() {
    const u = this.url?.url;
    if (u && u.indexOf('wizard') >= 0) {
      this.getData(this.url.url);
    }
    this.tryMountGrowSdk();
    this.startTranzilaSafetyTimer();
    this.syncPopupA11y();
  },
  updated() {
    this.syncPopupA11y();
  },
  beforeUnmount() {
    this.clearGrowSafetyTimer();
    this.clearTranzilaSafetyTimer();
    invalidateGrowWalletAttempt();
    if (this.content?.form?.hosted_fields?.thtk) {
      teardownTranzilaSession(this.content.form.hosted_fields.thtk);
    }
    this.growMountToken += 1;
    this.growLastMountedAuthCode = null;
    this.clearPopupA11yMeta();
  },
  computed: {
    iframeTitle() {
      const titleText = this.plainTextFromHtml(this.content?.title);
      if (titleText) {
        return titleText;
      }
      if (this.content?.form?.auth_code) {
        return 'תשלום בכרטיס אשראי';
      }
      if (this.content?.form?.hosted_fields) {
        return 'תשלום בכרטיס אשראי';
      }
      if (this.content?.form?.iframe_url) {
        return 'תוכן מוטמע';
      }
      return undefined;
    },
    popupA11yRegistration() {
      const c = this.content;
      if (!c || this.wizard) {
        return { titleId: null, describedBy: null };
      }
      if (c.form?.iframe_url || c.form?.auth_code || c.form?.hosted_fields || c.form) {
        if (c.title) {
          return { titleId: this.popupTitleId, describedBy: null };
        }
        return { titleId: null, describedBy: null };
      }
      if (this.campaignOffer) {
        return {
          titleId: c?.header?.title_html ? this.popupTitleId : null,
          describedBy: c?.body?.text_html ? this.popupAlertBodyId : null,
        };
      }
      if (c.body) {
        return { titleId: this.popupTitleId, describedBy: this.popupAlertBodyId };
      }
      if (c.popup_content?.header?.title_html) {
        return { titleId: this.popupTitleId, describedBy: null };
      }
      if (c.dish && c.title) {
        return { titleId: this.popupTitleId, describedBy: null };
      }
      if (c.str || this.contentIsString()) {
        return { titleId: this.popupAlertBodyId, describedBy: null };
      }
      return { titleId: null, describedBy: null };
    },
  },
  methods: {
    syncPopupA11y() {
      this.registerPopupA11yMeta(this.popupA11yRegistration);
    },
    plainTextFromHtml(html) {
      if (!html || typeof document === 'undefined') {
        return '';
      }
      const el = document.createElement('div');
      el.innerHTML = html;
      return (el.textContent || '').trim();
    },
    clearGrowSafetyTimer() {
      if (this.growSafetyTimer) {
        clearTimeout(this.growSafetyTimer);
        this.growSafetyTimer = null;
      }
    },
    clearTranzilaSafetyTimer() {
      if (this.tranzilaSafetyTimer) {
        clearTimeout(this.tranzilaSafetyTimer);
        this.tranzilaSafetyTimer = null;
      }
    },
    startTranzilaSafetyTimer() {
      this.clearTranzilaSafetyTimer();
      if (this.content?.form?.auth_code) {
        return;
      }
      const hf = this.content?.form?.hosted_fields;
      if (!hf) {
        return;
      }
      const timeoutMs = remainingHandshakeMs(hf, this.content.page_timout);
      this.tranzilaSafetyTimer = setTimeout(() => {
        this.setPopupError(SESSION_EXPIRED_HE);
        teardownTranzilaSession(hf.thtk);
        this.$emit('close');
      }, timeoutMs || 1);
    },
    setPopupError(message) {
      const el = document.getElementById('popup-error-message');
      if (el) {
        el.innerHTML = message || '';
      }
    },
    tryMountGrowSdk() {
      const authCode = normalizeAuthCode(this.content?.form?.auth_code);
      if (!authCode) {
        return;
      }
      if (authCode === this.growLastMountedAuthCode) {
        return;
      }
      this.mountGrowSdk(authCode);
    },
    async mountGrowSdk(authCode) {
      const code = normalizeAuthCode(authCode ?? this.content?.form?.auth_code);
      if (!code) {
        return;
      }
      if (!canOpenGrowWallet(code)) {
        this.setPopupError(AUTH_CODE_RETRY_HE);
        this.popupLoadingIndicator = false;
        return;
      }
      const mountToken = ++this.growMountToken;
      this.clearGrowSafetyTimer();
      this.setPopupError('');
      this.popupLoadingIndicator = true;
      try {
        await this.$nextTick();
        await this.$nextTick();
        if (mountToken !== this.growMountToken) {
          return;
        }
        setGrowWalletSession({
          env: this.content.form.env,
          handlers: makeSdkHandlers({
            $this: this,
            onClose: () => this.$emit('close'),
          }),
        });
        if (mountToken !== this.growMountToken) {
          return;
        }
        await renderGrowWallet(code, this.content.form.env);
        if (mountToken !== this.growMountToken) {
          return;
        }
        this.growLastMountedAuthCode = code;
        const timeoutMs = this.content.page_timout || 240000;
        this.growSafetyTimer = setTimeout(() => {
          this.setPopupError('פג תוקף התשלום, נא לנסות שוב');
          this.$emit('close');
        }, timeoutMs);
      } catch (err) {
        if (mountToken !== this.growMountToken) {
          return;
        }
        console.error('Grow SDK mount failed', err);
        this.setPopupError(
          err?.code === 'GROW_AUTH_CODE_CONSUMED'
            ? AUTH_CODE_RETRY_HE
            : 'אירעה שגיאה בטעינת מסך התשלום'
        );
        this.popupLoadingIndicator = false;
      }
    },
    async getData(url) {
      this.loading = true;
      const data = await fetch2(this, url);
      if (Object.keys(data).length ===0) return ;

      this.wizard = data;
      this.loading = false;
    },
    async onSubmit() {
      if (this.content.form && this.content.form.submit && this.content.form.submit.cancel) {
        this.$emit('close');
        return;
      }
      this.isSubmitting = true; // Set isSubmitting to true
      let form = this.$refs.form;
      const response = await formSubmit(this, form, null, null);
      // eslint-disable-next-line
      if (response.hasOwnProperty("success") && response.success === false && response.error) {
        this.errorMessage = response.error;
        this.isSubmitting = false; // Reset isSubmitting to false
        return;
      }
      // eslint-disable-next-line
      else if (response.hasOwnProperty("success") && response.success === true && response.message) {
        this.responseMessage = response.message;
        if (response.content && response.content.buttons) {
          this.responseButtons = response.content.buttons; // Set responseButtons based on response content
        }
        this.isSubmitting = false; // Reset isSubmitting to false
        if (response.keep_open) {
          return;
        }
      }
      this.$emit('close', response.success, response, this.content?.requestId);
      this.isSubmitting = false; // Reset isSubmitting to false
    },
    async campaignBtnAction(btn) {
      if (!btn || this.posting) return;
      if (btn.cancel && !btn.url) {
        this.$emit('close');
        return;
      }
      if (btn.method !== 'POST' || !btn.url) {
        return;
      }
      this.posting = true;
      try {
        const response = await fetch(baseUrl(btn.url), {
          method: 'POST',
          redirect: 'manual',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
          },
          body: null,
        });
        if (response.status !== 200) {
          this.posting = false;
          return;
        }
        let data;
        try {
          data = await response.json();
        } catch (e) {
          this.posting = false;
          return;
        }
        if (data?.success === true && data?.close_popup === true) {
          this.posting = false;
          this.$emit('close');
          return;
        }
        if (data?.success === true && data?.popup_content) {
          this.$store.dispatch('showPopup', data.popup_content, 'center');
          this.posting = false;
          return;
        }
        this.posting = false;
      } catch (e) {
        this.posting = false;
      }
    },
    async btnAction(btn) {
      this.$emit('close');
      // console.log("IN btnAction")
      if (btn.method === 'POST') {
        // console.log("POST")
        try {
          let postData = {};
          if (btn.post_params) {
            btn.post_params.forEach(param => {
              postData[param.name] = param.val;
            });
          }

          // Send the POST request
          let response = await formSubmit(this, null, btn.href, postData);

          // Emit the response to the parent component (checkout view)
          this.$emit('orderUpdated', response);

        } catch (error) {
          console.error("Error sending POST request:", error);
        }
      } else {
        // console.log("GET")
        let link = btn.url || btn.href;
        if (link) {
          if (link.indexOf("add_to_cart") > 0) {
            let response = await formSubmit(this, null, link);
            if (response.popup_content || response?.prompt_json?.popup_content) {
              openCart(this,response);
              // if (this.$isDesktop(true) && response?.cart?.url) {
              //   this.$store.dispatch('showPopupWithUrl', response.cart.url);
              // } else if (response.popup_content || response?.prompt_json?.popup_content) {
              //   this.$store.dispatch('showPopup', response.popup_content || response?.prompt_json?.popup_content);
              // }
            }
          } else {
            if (this.$route.fullPath == link) {
              this.$router.go(0);
            } else if (link.indexOf("/") == 0) {
              const path = link.split('?')[0];
              if (this.$route.path == path){
                window.location.href = link;
              } else {
                this.$router.push(link);
              }
            }
          }
        }
      }
    },
    contentIsString() {
      return this?.content instanceof String;
    },
    openpopup(json) {
      this.$emit('close');
      this.$store.dispatch('showPopup', {form: json, requestId: this.content?.requestId});
    },
    customizeField(field) {
      field["desktopClass"] = "col-12";
      return field;
    },
    classSelector() {
      return this.content.form.style + '_iframe';
    }
  },
  watch: {
    popupA11yRegistration: {
      handler() {
        this.syncPopupA11y();
      },
      deep: true,
    },
    content: {
      handler(newContent) {
        this.syncPopupA11y();
        const authCode = normalizeAuthCode(newContent?.form?.auth_code);
        if (authCode) {
          if (newContent?.form?.hosted_fields) {
            console.warn("Tranzila hosted_fields ignored because auth_code is present");
          }
          this.clearTranzilaSafetyTimer();
          if (authCode === this.growLastMountedAuthCode) {
            return;
          }
          this.tryMountGrowSdk();
          return;
        }
        this.clearGrowSafetyTimer();
        if (newContent?.form?.hosted_fields) {
          this.startTranzilaSafetyTimer();
          return;
        }
        this.clearTranzilaSafetyTimer();
      },
      deep: true,
      immediate: false,
    },
    async $route(to/*, from*/) {
      if (to.hash === "#loading") {
        this.popupLoadingIndicator = true;
      }
      if (to.hash === "#loaded") {
        this.popupLoadingIndicator = false;
      }
    }
  }
}
</script>
<style scoped>
.popup-close-btn {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: #383838;
  line-height: inherit;
}

.new-address-btn {
  width: 100%;
  text-align: inherit;
  cursor: pointer;
  font: inherit;
}

.formfield-no-margin .formfield-margin-wrapper {
  margin: 0;
}

.card_iframe {
  width: 300px; 
  height: 450px; 
  margin: auto;
}
.credit_iframe {
  width: 300px; 
  height: 450px; 
  margin: auto;
}

.bit_iframe {
  z-index: 100;
  width: 100%;
  height: 100%;
  position: fixed;
  border: 0;
  top: 0;
  right: 0;
  background-color: transparent !important;
}
.apple_iframe {
  width: 300px; 
  height: 300px; 
  margin: auto;
}

.google_iframe {
  width: 300px; 
  height: 300px; 
  margin: auto;
}

.grow_wallet_container {
  width: 100%;
  min-height: 500px;
  margin: 0 auto;
}

.tranzila-hf-popup,
:deep(.tranzila-hf) {
  width: 100%;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px; /* Adjust height as needed */
}

.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.campaign-offer-btn-wrap {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.campaign-offer-disclaimer {
  width: calc(100% + 20px);
  margin-inline: -10px;
  text-align: center;
  font-size: 14px !important;
}

@media (max-width: 768px) {
  .popup-header-image {
    width: 340px;
  }
}

</style>